<template>
    <div class="overall-bg px-0">
        <b-row>
            <b-col>
                <TabView class="tabview-custom" ref="tabview" :scrollable="true">
                    <TabPanel>
                        <template #header>
                            <i class="pi pi-align-left pe-3"></i>
                            <span>All</span>
                        </template>
                        <div>
                            <AllItemsTableview />
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <template #header>
                            <i class="pi pi-shopping-bag pe-3"></i>
                            <span>With Rate Contract</span>
                        </template>
                        <div>
                            <RateContractItemsTableview />
                        </div>
                    </TabPanel>
                </TabView>
            </b-col>
        </b-row>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import AllItemsTableview from "../../../../../modules/Inventory/pages/Masters/Items/ItemMaster/DetailsTableview.vue";
import RateContractItemsTableview from "../../../../../modules/Inventory/pages/Transaction/RateContract/RateContractTableview.vue";

export default defineComponent({
    components: {
        AllItemsTableview,
        RateContractItemsTableview
    }
})
</script>
